import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    { icon: 'Shield', label: 'SSL Secured', color: 'var(--color-success)' },
    { icon: 'Lock', label: 'Data Encrypted', color: 'var(--color-primary)' },
    { icon: 'CheckCircle', label: 'Verified Partner', color: 'var(--color-secondary)' }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="flex flex-wrap items-center justify-center gap-8">
        {trustBadges?.map((badge, index) => (
          <div key={index} className="flex items-center gap-2.5">
            <Icon name={badge?.icon} size={18} color={badge?.color} />
            <span className="text-xs text-muted-foreground font-medium">{badge?.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;